<template>
  <v-list-group class="text" :sub-group="subGroup">
    <v-icon slot="prependIcon" class="text">{{
      subGroup ? null : item.icon
    }}</v-icon>
    <v-icon slot="appendIcon" class="text">mdi-chevron-down</v-icon>

    <template v-slot:activator>
      <v-list-item-title class="text"><strong>{{ $t(item.title) }}</strong></v-list-item-title>
    </template>

    <template v-for="(child, i) in item.subItems">
      <navigation-list-group
        v-if="isGroupItem(child)"
        :key="i"
        :item="child"
        subGroup
      ></navigation-list-group>
      <navigation-list-group-item
        v-else
        :key="i"
        :text="child.title"
        :icon="child.icon"
        :to="child.to"
        :budge="child.budge"
        class="mr-6"
      ></navigation-list-group-item>
    </template>
  </v-list-group>
</template>

<script>
import NavigationListGroupItem from './NavigationListGroupItem.vue';

export default {
  components: { NavigationListGroupItem },
  props: {
    item: {
      type: Object,
      default: () => ({
        title: "",
        icon: "",
        to: "",
        subItems: [],
      }),
    },
    subGroup: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    isGroupItem(item) {
      return item.children && item.children.length > 0;
    },
  },
};
</script>

<style>
</style>